import route from "@/constants/route";
import useColorMode from "@/hook/useColorMode";

export default function NotFound() {
    useColorMode()
    return (
        <main className="grid min-h-full w-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8 dark:bg-boxdark">
            <div className="text-center">
                <p className="text-base font-semibold text-indigo-600">404</p>
                <h1 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl dark:text-white">Page not found</h1>
                <p className="mt-6 text-base leading-7 text-gray-600 dark:text-white">Sorry, we couldn't find the page you're looking for.</p>
                <div className="mt-10 flex items-center justify-center gap-x-6">
                    <a
                        href={route.DASHBOARD}
                        className="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                    >
                        Go back home
                    </a>
                    <a href="#" className="text-sm font-semibold text-gray-900 dark:text-white">
                        Contact support <span aria-hidden="true">&rarr;</span>
                    </a>
                </div>
            </div>
        </main>
    );
};
